import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user) navigate("/admin", { replace: true });
  }, [checked, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1a1a1a] px-5 grain">
      <div className="relative z-10 w-full max-w-md bg-[#f9f6f0] p-8 md:p-10 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-8">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#da251d] text-white mb-4">
            <Lock size={24} />
          </span>
          <h1 className="font-display text-3xl font-bold">Panel de administración</h1>
          <p className="text-[#57534e] text-sm mt-2">Inca's Peruvian Grill</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="email">Correo</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              className="mt-1.5 bg-white"
              placeholder="admin@incasgrill.com"
            />
          </div>
          <div>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              className="mt-1.5 bg-white"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-[#da251d] text-sm" data-testid="login-error">{error}</p>}
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-[#da251d] hover:bg-[#b91c1c] text-white h-11 rounded-full font-semibold"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </Button>
        </form>
        <a href="/" className="block text-center text-sm text-[#57534e] mt-6 hover:text-[#da251d]">← Volver al sitio</a>
      </div>
    </div>
  );
}
